import { defineBlocksWithJsonArray } from 'blockly/core';

import { brightnessPercentField } from '../helpers/block-builders.js';
import { BEGINNER_SPEAKER_SOUND_OPTIONS } from './sound-constants.js';

const SOUND_STYLE = 'beginner_sound_blocks';

const speakerBlockDefinitions = [
  {
    type: 'beginner_speaker_play_sound',
    message0: 'play sound %1',
    args0: [
      {
        type: 'field_dropdown',
        name: 'SOUND',
        options: BEGINNER_SPEAKER_SOUND_OPTIONS,
      },
    ],
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Plays a sound on the speaker.',
    helpUrl: '',
  },
  {
    type: 'beginner_speaker_pause',
    message0: 'pause sound',
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Pauses the sound on the speaker.',
    helpUrl: '',
  },
  {
    type: 'beginner_speaker_resume',
    message0: 'resume sound',
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Resumes the sound on the speaker.',
    helpUrl: '',
  },
  {
    type: 'beginner_speaker_stop',
    message0: 'stop sound',
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Stops the sound on the speaker.',
    helpUrl: '',
  },
  {
    type: 'beginner_speaker_set_volume',
    message0: 'set speaker volume %1 %',
    args0: [brightnessPercentField('VOLUME', 80)],
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Sets how loud the speaker plays (0–100%).',
    helpUrl: '',
  },
];

export function registerBeginnerSpeakerBlocks(): void {
  defineBlocksWithJsonArray(speakerBlockDefinitions);
}
